const b2bZh = {
  zh: {
    nb: {
      new_business: '新件處理',
      service_records: '服務紀錄',
      clients: '客戶資料',
      reports: '管理報表',
      commissions: '對帳表',
      my_profile: '我的資料',
      keywords: '保單申請號碼  /  保單號碼  /  客戶名稱  /  顧問',
      insurance_plan: '保險計劃',
      investment_link: '投資相連保險',
      fund_platform: '投資',
      transfer_in: '轉入客戶',
      private_bank: '私人理財',
      trust: '信託',
      legend: '說明',
      stage_1: '第一階段',
      stage_2: '第二階段',
      stage_3: '第三階段',
      stage_4: '第四階段',
      stage_5: '第五階段',
      stage_6: '第六階段',
      stage_7: '第七階段',
      stage_other: '其他',
      stage_1_desc: '{{siteShortName}} 已收到申請文件',
      stage_2_desc: '{{siteShortName}} 初步發現缺件',
      stage_3_desc: '申請件送抵產品公司',
      stage_4_desc: '產品公司要求補件',
      stage_5_desc: '審核完成並等待簽發保單',
      stage_6_desc: '{{siteShortName}} 收到保單 / 保單已由保險公司直接送到客戶通訊地址',
      stage_7_desc: '{{siteShortName}} 收到客戶保單簽收回條正本 / 帳戶開啟',
      stage_other_desc: '申請已取消',
      oaa: 'Online Application Assistance',
      new_policy_detail: '新保單詳情',
      service_record_detail: '服務紀錄詳情',
      statement: '月結單',
      close: '關閉',
      table_fields: {
        policy_no: '申請／保單號碼／計劃名稱 *',
        client: '客戶名稱',
        insured: '受保人',
        modal_premium: '每期保費',
        plan_start_date: '計劃生效日',
        app_rec_date: '申請書收到日期 *',
        stage: '階段 *',
        consultant: '顧問 *',
        details: '詳細資料',
      },
    },
    clients: {
      keywords: '客戶名稱  /  客戶號碼  /  保單號碼  /  計畫名稱  /  顧問',
      exclude_policy_status: '搜尋結果不包含',
      fund_keywords: '基金名稱  /  基金編號',
      client_product_type: '產品種類',
      client_detail: '客戶資料',
      documents: '文件',
      table_fields: {
        client: '客戶名稱 *',
        policy_no: '申請／保單號碼／計劃名稱 *',
        insured: '受保人',
        modal_premium: '每期保費',
        status: '狀態 *',
        consultant: '顧問 *',
        details: '詳細資料',
      },
    },
    sr: {
      keywords: '保單號碼 / 客戶名稱',
      export_excel: '滙出',
      sr_all: '- 全部 -',
      sr_status: '狀態',
      sr_type: '服務種類',
      table_fields: {
        policy_no: '申請／保單號碼／計劃名稱 *',
        client: '客戶名稱',
        insured: '受保人',
        sr_type: '服務種類',
        sr_status: '狀態 *',
        created_date: '新增日期 *',
        complete_date: '完成日期 *',
        consultant: '顧問 *',
        details: '詳細資料',
      },
    },
    my_profile: {
      title: '我的帳號',
      subtitle: '以下資料僅供 {{siteName}} 記錄之用。',
      name: '姓名',
      code: '合作伙伴號碼',
      op_email: '電郵 ( 作業 )',
      ac_email: '電郵 ( 會計 )',
      contract_addr: '合約地址',
      corr_addr: '聯絡地址',
      remark: '如需更改以上資料，請填寫「更改聯絡資料表格」並電郵到相關的服務團隊。',
    },
    commission: {
      issue_month: '報表月份',
      pdf_version: 'PDF版本',
    },
    onlineAppl: {
      producer_info: '顧問資料及申請內容',
      information: '資料',
      save: '存檔',
      submit: '提交',
    },
    layout: {
      welcome: '歡迎, ',
    },
    statement: {
      provider_statement: '交易紀錄 / 產品公司報表',
      other_policies: '請選擇其他保單',
      choose_month: '請選擇月份 *',
      choose_currency: '請選擇貨幣',
      pdf_version: 'PDF版本',
      last_6_month_remarks: '* 可供下載過往六個月的投資組合報告',
    },
  },
};

export default b2bZh;
